export default __webpack_public_path__ + "static/media/video-intro-mobile-medium.7dd9adbc.mp4";